import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {envUtil} from './env';
import {writeLanguage} from '@px/storage/lang';
import {readToken, writeToken} from '@px/storage/token';

export const appVersion$ = new BehaviorSubject('');
export const appPlatform$ = new BehaviorSubject('');
export const appToken$ = new ReplaySubject<string>(1);

declare global {
  interface Window {
    Bridge: any;
    getAppInfo: any;
  }
}

export const bridge = {
  postMessage(msg) {
    if (envUtil.isApp) {
      window.Bridge.postMessage(msg);
    }
  },
  postJSON(msg) {
    if (envUtil.isApp) {
      window.Bridge.postMessage('JSON:' + JSON.stringify(msg));
    }
  },
};

export const semver = {
  gt(appVersionA, appVersionB) {
    try {
      return versionToNum(appVersionA) > versionToNum(appVersionB);
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  gte(appVersionA, appVersionB) {
    try {
      return versionToNum(appVersionA) >= versionToNum(appVersionB);
    } catch (error) {
      console.log(error);
      return false;
    }
  },
};

export function versionToNum(appVersion) {
  return appVersion
    .toString()
    .split('.')
    .map((o, index) => Number(o) * Math.pow(10, (2 - index) * 2))
    .reduce((p, c) => p + c, 0);
}

(function initAppEnv() {
  if (envUtil.isApp) {
    window.getAppInfo = function (data) {
      let token = readToken();
      const appInfo = JSON.parse(data);
      if (appInfo.lang) {
        writeLanguage(appInfo.lang);
      }
      const appToken = appInfo.token;
      writeToken(appToken);

      appVersion$.next(appInfo.version);
      appPlatform$.next(appInfo.platform + '-H5');
      appToken$.next(appToken);

      if (token != appToken) {
        window.location.reload();
      }
    };
    bridge.postMessage('getAppInfo');
  }
})();
